/** Routes that must never be used as return destinations (would cause redirect loops). */
const GUEST_ONLY = ["/login"];

/**
 * Validates and returns a safe same-origin return path.
 *
 * Falls back to "/dashboard" when the value is:
 * - empty / null / undefined
 * - not starting with "/" (external URL)
 * - starting with "//" (scheme-relative — potential open redirect)
 * - a guest-only route such as /login (would cause an infinite redirect loop)
 */
export function getSafeReturnTo(raw: string | null | undefined): string {
  if (!raw) return "/dashboard";
  if (!raw.startsWith("/") || raw.startsWith("//")) return "/dashboard";

  const pathname = raw.split("?")[0].split("#")[0];
  if (GUEST_ONLY.some((r) => pathname === r || pathname.startsWith(r + "/"))) {
    return "/dashboard";
  }

  return raw;
}
